<div class="sec-title">
  <h1>Calendrier des vendeurs</h1>
  <div class="alert alert-success p-3" role="alert" *ngIf="showMessage">
    {{messageSuccess}}
  </div>
</div>
<hr>
<div class="col-sm-12 ">
  <form [formGroup]="editCalendarForm" (ngSubmit)="onSubmit(editCalendarForm.value)" class="col-12" novalidate>
    <div class="row mb-3">
      <div class="col-lg-3 col-sm-12">
        <select name="submissions_by_sales" id="submissions_by_sales" formControlName="submissions_by_sales" class="form-select" (change)="onChange()">
          <option default>Choisir un compte</option>
          <option *ngFor="let sale of salesList" [value]="sale.account_id">
            {{sale.first_name}} {{sale.last_name}}
          </option>
        </select>
      </div>
    </div>
  </form>

  <div class="row col-sm-12">
    <div class="col-sm-12 col-lg-3">
      <div class="mt-5">
        <ul class="list-group col-12" id="external-events">
          <li class="list-group-item col-12" >
            <form [formGroup]="searchSubmissionForm" (ngSubmit)="onSubmitSearch(searchSubmissionForm.value)" novalidate>
              <div class="form-group input-group mb-3">
                <label for="search_submission" class="visually-hidden">Recherche</label>
                <input type="text" class="form-control" name="search_submission" id="search_submission" formControlName="search_submission" placeholder="Recherche...">
                <div class="input-group-append">
                  <button type="submit" class="input-group-text right-action-btn">
                    <i title="Recherche" class="bi bi-search"></i>
                  </button>
                  <div class="row mt-3 ms-3 mb-3 strong">
                    {{no_results_message}}
                  </div>
                </div>
              </div>
            </form>
          </li>
          <div class="search_result_div">
          <li class="list-group-item col-12" *ngFor="let submission of submissionsNotAssignedList; let i = index;">
            <div id="draggable-el-{{i}}" class="client-event badge pill text-bg-primary col-12" data-id="{{submission.submission_id}}">
              <div class="float-lg-start client-event-label float-lg-start col-8">SOUMISSION</div>
              <div class="float-lg-end">
                <button type="button" class="btn btn-outline-secondary btn-action-delete left-action-btn white white-bg btn-small" id="holdSubmission" (click)="holdSubmission(submission.submission_id)">
                  <i class="bi bi-x-octagon-fill" title="Retirer de la liste"></i>
                </button>
                <a type="button" class="btn btn-outline-secondary middle-action-btn white btn-small" href="/client/{{submission.client_id}}/editer">
                  <i class="bbi bi bi-person-fill" title="Modifier le client"></i>
                </a>
                <a type="button" class="btn btn-outline-secondary right-action-btn white btn-small" href="/soumission/{{submission.submission_id}}/editer">
                  <i class="bi bi-pencil-square" title="Voir la soumission"></i>
                </a>
              </div>
              <div class="float-lg-start client-event-label col-12"> #{{submission.submission_no}}</div>
              <div class="float-lg-start me-2">{{submission.client_first_name}} {{submission.client_last_name}}</div>
              <div class="float-lg-start">{{submission.address}}<span *ngIf="submission.city != '' ">, {{submission.city}}</span></div>
            </div>
          </li>
          </div>
        </ul>
      </div>
    </div>

    <div class="col-sm-12 col-lg-9 mt-3">
      <full-calendar #calendar [options]="calendarOptions"></full-calendar>
    </div>
  </div>
</div>

<div id="eventModal" class="modal fade" tabindex="-1">
  <!-- Vertically centered scrollable modal -->
  <div class="modal-dialog modal-lg modal-dialog-centered modal-dialog-scrollable">
      <div class="modal-content">
          <div class="modal-header">
              <h5 class="modal-title">{{modalTitle}}</h5>
              <button type="button" id="updatePropositionForm-close" class="btn-close" data-bs-dismiss="modal" aria-label="Fermer"></button>
          </div>
          <div class="modal-body">
              <div class="form-group mb-3">
                <address>{{eventAddress}}</address>
              </div>
              <div class="form-group mb-3">
                <span>Début: </span><span>{{eventStartDate}}</span>
              </div>
              <div class="form-group mb-3">
                <span>Fin: </span><span>{{eventEndDate}}</span>
              </div>
              <div class="form-group mb-3">
                <button type="button">Voir plus de détails</button>
              </div>
          </div>
          <div class="modal-footer">
              <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Fermer</button>
          </div>
      </div>
  </div>
</div>
<hr>